import ReactDOM from "react-dom";
import React from "react";
import MegaMenu from "./MegaMenu/index";

const init = () => {
  /**
   * Using the MegaMenu
   *
   * add the 'data-mega-menu="{Items JSON}"' to the desired HTML element and specifiy the injection display from there
   */
  const menus = document.querySelectorAll("[data-mega-menu]");
  // loop through the menus and pass the template Data Accordingly
  menus.forEach((element) => {
    const menuData = JSON.parse(element.getAttribute("data-mega-menu"));
    const menuType = element.getAttribute("data-menu-type");
    ReactDOM.render(<MegaMenu items={menuData} menuType={menuType} />, element);
  });
  // resize this padding Dynamically when we change the viewport
  if (menus) {
    setBodyPadding();
    window.addEventListener("resize", setBodyPadding);
    window.addEventListener("orientationchange", setBodyPadding);
  }
};

const setBodyPadding = () => {
  // append some padding based on the route dynamically
  const main = document.getElementsByClassName("site-wrap")[0];
  const header = document.getElementById("site-navigation-container");
  main.style.paddingTop = header.offsetHeight + "px";
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/megamenu.js